import Box from '@mui/material/Box';
import type { JSX } from 'react';

import { Contacts } from '~components/Order/Contacts';

import { useOrderFormV3Context } from '../OrderFormV3Context';

/**
 * Renders contacts. Render-only wrapper: this row has NO card wrapper — the
 * embedded legacy Contacts renders its own Card and owns the contact arrays
 * and typeaheads (no fork). The Box margin is the legacy spacing verbatim;
 * parentData / defaultData mirror the legacy wiring off context (projectData
 * is live since useProjectDataFetch).
 */
export function ContactsPanel(): JSX.Element {
  const { defaultOrder, isSalespersonRequired, projectData } = useOrderFormV3Context();

  return (
    <Box sx={{ mt: 2 }}>
      <Contacts
        parentData={projectData}
        defaultData={defaultOrder}
        isSalespersonRequired={isSalespersonRequired}
      />
    </Box>
  );
}
